import React from 'react';

import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Card, Message} from '@weezevent/nacre';
import EventCreationDates from '../../event_creation/eventCreationDates';


export default function DateForm({eventUseSessions, formEvent, onChange, onChangeObject, isSubmitting, eventErrors, id='event-form-dates'}){
    const { t } = useTranslation();

    return (
        <Card.FormStep
            title={t('ticket.event.edit.datesTitle')}
            subtitle={t('ticket.event.edit.dateSubtitle')}
            rightComponent={
                <Message type="tips" title={t('ticket.common.tips')} mini>
                    {t('ticket.event.edit.dateTips')}
                </Message>
            }
            id={id}
        >
            <EventCreationDates
                formEvent={formEvent}
                onChangeObject={dates => onChangeObject(dates, true)}
                isSubmitting={isSubmitting}
                onChange={onChange}
                edit
                eventUseSessions={eventUseSessions}
                eventErrors={eventErrors}
            />
        </Card.FormStep>
    );
}

DateForm.propTypes ={
    formEvent: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeObject: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    eventUseSessions: PropTypes.bool
};